// extracted by mini-css-extract-plugin
module.exports = {"seasonLabel":"style_seasonLabel__3LWcO"};